import { darkCornflowerBlue1 } from "../../designer/ColorPickerField/ColorPickerField.contants";

export const defaults = {
  fontFamily: "Arial",
  fontSize: 16,
  fontWeight: "normal",
  lineHeight: 1.4,
  textAlign: "left",
  strokeWidth: 1,
  textColor: "#2D2D2D",
  linkColor: darkCornflowerBlue1.color,
  fill: "#ffffff",
  stroke: "#2D2D2D",
};
